"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var omit_1 = __importDefault(require("lodash/omit"));

var react_1 = __importStar(require("react"));

var index_1 = __importDefault(require("../AutoCompleteInput/index"));

var Button_1 = __importStar(require("../Button"));

var Icon_1 = require("../Icon");

var EditItemsModal_1 = __importDefault(require("./EditItemsModal"));

var FilterItem_1 = __importDefault(require("./FilterItem"));

var FilterBar =
/** @class */
function (_super) {
  __extends(FilterBar, _super);

  function FilterBar() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    /**
     * After any filter selection changes, call this method.
     */


    _this.filterChange = function (itemID, values, operator) {
      var _a;

      var filters;
      var id = Array.isArray(itemID) ? itemID.toString() : itemID;

      if (values) {
        filters = __assign(__assign({}, _this.props.selected || {}), (_a = {}, _a[id] = {
          values: values,
          operator: operator
        }, _a));
      } else {
        filters = omit_1.default(_this.props.selected, id);
      }

      if (_this.props.onFilterChange) {
        _this.props.onFilterChange(filters, _this.props.visible, false);
      }
    };

    _this.filterVisibilityOrOrderChange = function (visible) {
      if (_this.props.onFilterChange) {
        _this.props.onFilterChange(_this.props.selected || {}, visible, false);
      }
    };
    /**
     * Reset filter button.
     */


    _this.resetFilters = function () {
      if (_this.props.onFilterChange) {
        // Maybe in this case they will want default state of filters
        _this.props.onFilterChange({}, _this.props.visible, true);
      }
    };
    /**
     * Confirm quick search.
     */


    _this.confirmQuickSearch = function () {
      if (_this.props.search && _this.props.search.onSearchConfirm) {
        _this.props.search.onSearchConfirm();
      }
    };

    _this.onChangedValue = function (value) {
      if (_this.props.search && _this.props.search.onChangedValue) {
        _this.props.search.onChangedValue(value);
      }

      _this.confirmQuickSearch();
    };

    _this.keyDownQuick = function (event) {
      if (event.key === 'Enter') {
        _this.confirmQuickSearch();
      }
    };

    return _this;
  } // tslint:disable-next-line:cognitive-complexity


  FilterBar.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        search = _a.search,
        filters = _a.filters,
        selected = _a.selected,
        visible = _a.visible,
        children = _a.children,
        _b = _a.localization,
        resetFilters = _b.resetFilters,
        editFilters = _b.editFilters,
        confirm = _b.confirm;
    var row = [];

    if (search) {
      var inputProps = {
        placeholder: search.placeholder,
        size: 40,
        className: 'search_input',
        iconStop: Icon_1.IconType.Search,
        onKeyDown: this.keyDownQuick
      };
      row.push(react_1.default.createElement("div", {
        key: "search",
        className: "without_label item"
      }, react_1.default.createElement(index_1.default, {
        inputProps: inputProps,
        suggestions: search.suggestions || [],
        searchSuggestions: search.autocomplete,
        onInputChange: search.onChangedValue,
        value: search.value,
        onSelected: this.onChangedValue
      })));
    }

    if (filters && filters.length > 0 && visible) {
      filters.reduce(function (accumulator, item) {
        var simpleId = Array.isArray(item.id) ? item.id.toString() : item.id;

        if (visible.indexOf(simpleId) >= 0) {
          accumulator.push(__assign(__assign({}, item), {
            id: simpleId
          }));
        }

        return accumulator;
      }, []).sort(function (a, b) {
        return visible.indexOf(a.id) - visible.indexOf(b.id);
      }).forEach(function (item) {
        var selectedValues;

        if (selected && selected.hasOwnProperty(item.id)) {
          selectedValues = selected[item.id].values;
        }

        row.push(react_1.default.createElement(FilterItem_1.default, __assign({
          localization: _this.props.localization,
          onChange: _this.filterChange,
          selected: selectedValues,
          key: item.id + "_filter",
          className: "item"
        }, item)));
      }); // Filters and labels are optional

      if (this.props.hideReset !== true || this.props.hideFilterSettings !== true) {
        if (this.props.hideReset !== true) {
          row.push(react_1.default.createElement("div", {
            className: "without_label item",
            key: "reset-button"
          }, react_1.default.createElement(Button_1.default, {
            variant: Button_1.ButtonVariant.Dangerous,
            onClick: this.resetFilters
          }, resetFilters)));
        }

        if (this.props.hideFilterSettings !== true) {
          row.push(react_1.default.createElement(EditItemsModal_1.default, {
            className: "without_label item",
            key: "edit_filters_modal",
            editMessage: editFilters,
            confirmMessage: confirm,
            columns: this.props.filters,
            visible: this.props.visible,
            onChange: this.filterVisibilityOrOrderChange
          }));
        }
      }
    }

    return react_1.default.createElement("div", {
      className: "emankit__filter_bar"
    }, row, children);
  };

  FilterBar.defaultProps = {
    resetFilter: undefined,
    onFilterChange: undefined,
    visible: []
  };
  return FilterBar;
}(react_1.Component);

exports.default = FilterBar;